import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import { Text } from '@feathr/components';

import { useDonationFormBuilder } from '../../useDonationFormBuilder';

import * as styles from './RightPanelTabs.css';

function RightPanelTabsBeta(): JSX.Element {
  const { formName } = useDonationFormBuilder();

  return (
    <div className={styles.root}>
      <span className={classNames(styles.tab, styles.tabBeta)}>
        <Text.LargeSemibold>{formName}</Text.LargeSemibold>
      </span>
    </div>
  );
}

export default observer(RightPanelTabsBeta);
